import { render } from "./BusesInline.vue?vue&type=template&id=63fcf5c1"
import script from "./BusesInline.vue?vue&type=script&lang=js"
export * from "./BusesInline.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__